import { JobStatus } from '../../../enums/job-status.enum';

export class ChangeShiftStatus {
    public static readonly type = '[JobsPlacements] Change shift status';

    constructor(public id: number, public status: JobStatus) {}
}
